import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { LayerGroup, LayersControl } from 'react-leaflet'
import { HeatLayer } from '../components/HeatLayer'
import { LocalityDeviations } from '../components/LocalityDeviations'
import { totalDeviationMultiplier } from '../constraints'
import { ILocality, IMooring, IPosition } from '../../../../../generated-types'
import { IGroupSelector } from '../MapComponent'
import { mapCenterCal } from '../../../../../utils/mapCenterCal'

export const DeviationLayers: React.FC<{
  positions?: IPosition[]
  moorings?: IMooring[]
  localities?: ILocality[]
  groupSelector: IGroupSelector
}> = ({ positions, moorings, localities, groupSelector }) => {
  const { t } = useTranslation(['map', 'common'])

  const selectedLocalityDeviations = useMemo(() => {
    const result: number[][] = []
    const allPositions = positions ?? moorings?.flatMap(m => m.positions) ?? []
    if (allPositions.length > 0) {
      const deviationsCount = allPositions.map(p => p.deviationsCount ?? 0).reduce((a, b) => a + b, 0)
      if (deviationsCount > 0) {
        const center = mapCenterCal(allPositions as IPosition[]) as number[] | undefined
        if (center) {
          result.push([...center, deviationsCount * totalDeviationMultiplier])
        }
      }
    }
    return result
  }, [positions, moorings])

  return (
    <>
      <LayersControl.Overlay name={`<b><u>${t('deviation-overview')}</u></b>`} checked={groupSelector.deviation}>
        <LayerGroup></LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.Overlay name={t('selected-locality')} checked={groupSelector.deviation}>
        <LayerGroup>
          <HeatLayer deviationPositions={selectedLocalityDeviations} />
        </LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.Overlay name={t('all-localities')} checked={groupSelector.deviation}>
        <LayerGroup>
          <LocalityDeviations
            positions={positions as IPosition[]}
            moorings={moorings as IMooring[]}
            localities={localities as ILocality[]}
          />
        </LayerGroup>
      </LayersControl.Overlay>
    </>
  )
}
